module.exports = __webpack_public_path__ + "img/mobile-banner-sm.849d0543.png";